import React, { useEffect, useState } from "react";
import { useWallet } from "./SignedWalletProvider"; // adjust path as needed
import PlanRadioGroup from "./PlanRadioGroup";
// import PayDeeporbUSDC from './PayDeeporbUSDC'; // Adjust the import path

export const FeaturePanel = ({ featureId, apiBaseUrl }) => {
  const { jwtToken } = useWallet();
  const [featureData, setFeatureData] = useState(null);
  const [error, setError] = useState(null);
  const [subscription, setSubscription] = useState(null);

  useEffect(() => {
    if (!featureId || !apiBaseUrl || !jwtToken) return;
    const fetchFeature = async () => {
      try {
        const res = await fetch(`${apiBaseUrl}/feature/${featureId}`, {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
        });
        if (!res.ok) throw new Error(`Error ${res.status}`);
        const data = await res.json();
        setFeatureData(data);
        setSubscription(data.userFeatureSubscription);
      } catch (err) {
        setError("Failed to load feature details.");
      }
    };
    fetchFeature();
  }, [featureId, apiBaseUrl, jwtToken]);

  if (error) return <div className="text-red-500">{error}</div>;
  if (!featureData) return <div>Loading feature details...</div>;

  const { feature, userFeatureConfig } = featureData;

  const handlePlanChange = (planId) => {
    // Implement plan change logic here, e.g., call an API to update user's plan
    console.log("Selected plan ID:", planId);


    const fetchPostSubscription = async () => {
      try {
        const res = await fetch(`${apiBaseUrl}/feature/${featureId}/subscribe?plan_id=${planId}`, {
          method: 'POST',
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
        });
        if (!res.ok) throw new Error(`Error ${res.status}`);
        const data = await res.json();
        setSubscription(data.subscription);
      } catch (err) {
        setError("Failed to load feature details.");
      }
    };
    fetchPostSubscription();
  }

  return (
    <div className="w-full flex flex-col items-start justify-start text-left">
      <div className="p-6 rounded-lg bg-white dark:bg-gray-800 shadow-md w-full">
        <h2 className="text-3xl font-bold mb-2 mt-0">{feature.title}</h2>
        <p className="mb-4 text-gray-700 dark:text-gray-300 text-xl">{feature.description}</p>
        <div className="mb-2">
          <span className="font-semibold">Active:</span>{" "}
          <span className={feature.active ? "text-green-600" : "text-red-600"}>
            {feature.active ? "Yes" : "No"}
          </span>
        </div>
        <div className="mb-2">
          <span className="font-semibold">Enabled:</span>{" "}
          <span className={userFeatureConfig?.isEnabled ? "text-green-600" : "text-red-600"}>
            {userFeatureConfig?.isEnabled ? "Yes" : "No"}
          </span>
        </div>
        <div className="mb-2">
          <span className="font-semibold">Feature Type:</span> {feature.featureType}
        </div>

        {userFeatureConfig?.isEnabled && feature.active && (
          <div className="mt-4">
            <span className="text-lg">You have access to this feature.</span>
          </div>
        )}
        {!userFeatureConfig?.isEnabled && feature.active && !subscription && (
          <div className="mb-2">
            <h4 className="font-semibold">Choose a plan to use this feature.</h4>
            <PlanRadioGroup feature={feature} value={userFeatureConfig?.planId} onChange={handlePlanChange} />
          </div>
        )}
        {subscription && !userFeatureConfig?.isEnabled && (
          <div className="mt-4 p-4 bg-gray-100 dark:bg-gray-700 rounded-lg w-full">
            <h4 className="font-semibold mb-2">Your Need To Pay to Activate</h4>
            <div className="mb-1">
              <span className="font-semibold">Plan:</span> {subscription.plan.planType}
              <div>
                {/* <PayDeeporbUSDC amount={subscription.plan.price} invoiceId={subscription.invoiceId} /> */}
              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
};